const formatter = Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 2 });

export default function formatMoney (number) {
  return formatter.format(number);
}